import script from "./5.HaveTanningLast48Hours.vue?vue&type=script&setup=true&lang=ts"
export * from "./5.HaveTanningLast48Hours.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__